import React from 'react';
import { PageHeader as PageHeaderComp } from 'adc-ui-components';

const PageHeader = () => (
  <PageHeaderComp />
);

export default PageHeader;
